module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm3_jp.40e99d57cc1e18b00b736455861c0c15.png";